import * as classnames from 'classnames'
import * as React from 'react'
import * as classNames from './subject-summary.css'

export interface IProps {
  className?: string
  subjectIdentifier: string
  isTreatmentActive: boolean
  isTreatmentArchived: boolean
}

export class SubjectSummary extends React.PureComponent<IProps, {}> {
  public render() {
    // TODO I18N
    return (
      <div className={this.props.className}>
        {this.props.isTreatmentArchived
          ? <p className={classnames(classNames.treatmentArchived, classNames.treatmentStatus)}>
              prescription is archived
            </p>
          : this.props.isTreatmentActive
            ? <p className={classnames(classNames.treatmentActive, classNames.treatmentStatus)}>
                undergoing treatment
              </p>
            : <p className={classnames(classNames.treatmentInactive, classNames.treatmentStatus)}>
                not in treatment
              </p>
        }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_coordinator/src/components/subjects/subject-summary.tsx